import type { ServiceByCategory } from "@/types/services";

/**
 * Derived status for the Manage Services list.
 *
 * Two raw booleans come back from the API:
 *   - `is_active` — operational booking gate (Django admin "Active")
 *   - `visible`   — patient-facing visibility (Django admin "Visible")
 *
 * The list view collapses them into a single chip with three states so the
 * row stays scannable. Detail view + form expose the raw flags individually.
 */
export type ServiceStatus = "active" | "hidden" | "inactive";

export interface ServiceStatusMeta {
  status: ServiceStatus;
  label: string;
  /** Maps to the shared `Badge` variant tokens. */
  variant: "success" | "neutral" | "critical";
}

export const getServiceStatus = (
  service: Pick<ServiceByCategory, "is_active" | "visible">
): ServiceStatusMeta => {
  if (service.is_active === false) {
    return { status: "inactive", label: "Inactive", variant: "critical" };
  }
  if (service.visible === false) {
    return { status: "hidden", label: "Hidden", variant: "neutral" };
  }
  return { status: "active", label: "Active", variant: "success" };
};
